export default "__VITE_ASSET__C5u2Bx_V__"